import DatePicker from "components/datePicker";
import { IExchangeRateItem } from "interfaces";
import { get, isEmpty } from "lodash";
import moment from "moment";
import { CURRENCY_LIST } from "utills/constants";

export const Filter = ({ currentFilterValues, setFilters, exchangeRateData}: {currentFilterValues: any, setFilters: any, exchangeRateData?: IExchangeRateItem}) => {
  const currency = CURRENCY_LIST.find(currency => currency.code === exchangeRateData?.base);
  return (
    <div className="w-full flex flex-col gap-y-4 md:flex-row md:items-end md:gap-x-3">
      <div className="flex-1 md:max-w-xs">
        <div>
          <DatePicker
            id="created_at"
            placeholder="Created At"
            className="bg-white"
            value={currentFilterValues.created_at}
            onChange={(date: any) => setFilters({
              created_at: date === null ? "" : moment(date).format("YYYY-MM-DD")
            })}
            maxDate={moment().toDate()}
          />
          {!isEmpty(currency) ? (
            <p className="text-sm mt-2">
              Based on 1 {get(currency, "code", "")} ({get(currency, "name", "")})
            </p>
          ) : <></>}
        </div>
      </div>      
    </div>
  )
}